import React, { useEffect, useState } from 'react'
import logo from '../../assets/images/logo.png'
import { FormGroup, Label, Input, Button } from 'reactstrap'
import styles from '../../assets/css/rstyling.module.css'
import bg3 from "../../assets/utils/images/originals/citynights.jpg";
import { IoIosEye } from 'react-icons/io'
import { IoIosEyeOff } from 'react-icons/io'
import { useLocation } from 'react-router'
import axios from 'axios'
import reset_password_bg from "../../assets/images/reset_password_bg.jpg";
import { BACK_SERVER_URL } from '../../config/server';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert'

const ForgetPassword = () => {

    let { search } = useLocation();
    const query = new URLSearchParams(window.decodeURIComponent(search));
    const history = useNavigate()
    const [password, setPassword] = useState('')
    const [showPassword, setPassVisibility] = useState(false)
    const [err, setError] = useState({
        email: '',
        password: ''
    })

    const removeErr = () => {
        setError({
            password: ''
        })
    }

    const checkValidation = () => {
        removeErr()
        if (password === '') {
            setError((prevState) => ({ ...prevState, password: 'Password is required.' }))
        }
        if (password.split('').length < 8) {
            setError((prevState) => ({ ...prevState, password: 'Password must contain 8 characters.' }))
        }
        else {
            return true
        }
    }
    const resetPassword = () => {
        if (checkValidation()) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${query.get("token")}`;
            axios.put(BACK_SERVER_URL + "api/users/resetPassword?token=" + query.get("token"), { password: password })
                .then(response => {
                    Swal({
                        title: response.message ? response.message : "Password Reset",
                        text: response.content ? response.content : "Your password has been changed.",
                        icon: 'success'
                    })
                    .then( () => history('/login'))
                })
                .catch(err => {
                    Swal({
                        title: err.response ? err.response.data.name : "Error",
                        text: err.response ? err.response.data.content : "Please try again!",
                        icon: 'error'
                    });
                })
        }
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">

                    <div className="col-lg-4 p-0 d-none d-lg-block">
                        <div className={`h-100 ${styles.gradient_grbl}`}>
                            <div
                                style={{
                                    backgroundImage: "url(" + reset_password_bg + ")",
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    opacity: "0.2",
                                    zIndex: "5",
                                    backgroundSize: "cover",
                                    top: 0,
                                    left: 0
                                }} />

                        </div>
                    </div>

                    <div className="col-lg-8 col-md-12 bg-white">

                        {/* Logo */}
                        <ul class="nav justify-content-end">
                            <li class="nav-item">
                                <img src={logo} alt="logo" width="150px" style={{ margin: '2rem 1rem 0 0' }} />
                            </li>
                        </ul>

                        <div className="row">
                            <div className="col-lg-9 col-md-10 col-sm-12 pt-5 mt-5">

                                <div className="justify-content-center align-self-center">
                                    <h4 className="mb-0 ml-3">
                                        <h3 className="text-dark mb-2" style={{ fontWeight: '500' }}>Reset Password</h3>
                                        <p style={{ fontSize: '1rem' }}>Please enter a new password to reset your account.</p>
                                    </h4>

                                    <div className="col-md-10">
                                        <FormGroup className="mt-5">
                                            <Label className={styles.password}>New Password
                                                <Input type={showPassword ? "text" : "password"} onChange={(e) => setPassword(e.target.value)}
                                                    placeholder="Enter your password" className={err.password ? styles.is_invalid + " mt-2" : 'valid mt-2'} />
                                                <span className={styles.password_ico_position} onClick={() => setPassVisibility(!showPassword)}>{showPassword ? <IoIosEye /> : <IoIosEyeOff />}</span>
                                            </Label>
                                            <small className="text-danger">
                                                {err.password}
                                            </small>

                                        </FormGroup>
                                    </div>
                                    <div className="col-md-10">
                                        <Button className={`${styles.bg_blue} btn-hover-shine w-100`} onClick={() => resetPassword()}>Reset Password</Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
        // <div>
        //     <div className="container-fluid">
        //         <div className="row">
        //             <div className={`col-4 ${styles.login_background} h-100`}></div>
        //             <div className="col-8">
        //                 <ul class="nav justify-content-end">
        //                     <li class="nav-item">
        //                         <img src={logo} alt="logo" width="150px" style={{ margin: '2rem' }} />
        //                     </li>
        //                 </ul>

        //                 <div className="m-5">
        //                     <h4>Reset Password</h4>
        //                     <p> Please enter a new password to reset your account.</p>
        //                 <FormGroup className="mt-5">
        //                     <Label for="password">New Password</Label>
        //                     <Input type="password" className="w-50" name="password" id="password" placeholder="New Password" onChange={(e) => setPassword(e.target.value)} />
        //                 </FormGroup>
        //                 <Button className={`${styles.bg_blue} w-50`} onClick={ () => resetPassword() }>Reset Password</Button>
        //                 <p className="text-success">{state}</p>
        //                 </div>


        //             </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default ForgetPassword
